interface Props {
	optionData: { key: string; name: string }[];
	value: string;
	onChange: (key: string) => void;
	label?: string;
	disabled?: boolean;
}

const ToggleSwitch = ({ value, optionData, onChange, label, disabled }: Props) => {
	return (
		<div className="flex flex-row items-center">
			{label && (
				<span className="font-medium text-sm mr-2 hidden lg:inline" style={{ color: "#999999" }}>
					{`${label}: `}
				</span>
			)}
			<div
				className="h-11 rounded-xl flex flex-row items-center justify-between p-1.5 gap-2"
				style={{ backgroundColor: "#EDEFF3" }}
			>
				{optionData.map(({ key, name }) => {
					const isSelected = key === value;
					return (
						<button
							key={key}
							type="button"
							style={{
								backgroundColor: isSelected ? "#353535" : "transparent",
								color: isSelected ? "#FFFFFF" : "#9a9a9a",
							}}
							className={`
								font-semibold !text-sm h-8.5 !px-3 rounded-[12px] min-w-25
								flex items-center justify-center
								whitespace-nowrap
								transition-all duration-200
								${isSelected ? "shadow-sm !bg-black" : ""}
								${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:opacity-80"}
							`}
							onClick={() => {
								if (!disabled) {
									onChange(key);
								}
							}}
							disabled={disabled}
						>
							{name}
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default ToggleSwitch;
